import { render, staticRenderFns } from "./InvoiceBasisData.vue?vue&type=template&id=20cbef63&scoped=true"
import script from "./InvoiceBasisData.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceBasisData.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoiceBasisData.vue?vue&type=style&index=0&id=20cbef63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cbef63",
  null
  
)

export default component.exports